import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertPayments } from "./ExpertPaymentsHook";
// Set the default state values for each context
export const ExpertPaymentsContext = /*#__PURE__*/createContext({});
export const ExpertPaymentsContextProvider = ({
  children
}) => {
  const expertPayments = useExpertPayments();
  const paymentsContext = useMemo(() => ({
    ...expertPayments
  }), [expertPayments.payments]);
  return /*#__PURE__*/React.createElement(ExpertPaymentsContext.Provider, {
    value: paymentsContext
  }, children);
};
export const useExpertPaymentsContext = () => {
  return useContext(ExpertPaymentsContext);
};
ExpertPaymentsContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};